import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpUtils } from '../../common/http/http-utils';

import { JobsNotifierService } from './job-notifier.service';
import { HttpClient } from '@angular/common/http';

let url = '/hybridity/api/updatedJobsSinceLastRequest';
let interval = 10000;

@Injectable()
export class JobsPollingService {

    private subscription: Subscription;
    private pollFailCount = 0;
    private lastQueryTime: Number = 0;


    constructor(public http: HttpClient, public jobNotifier: JobsNotifierService) {
    }

    startJobPoller() {
        this.subscribeForJobs();
    }

    endJobPoller() {
        if ( this.subscription ) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
            this.lastQueryTime = 0;
            console.log('jobs poller unsubscribed');
        }
    }

    pollJobs() {
        if ( this.pollFailCount === 0 ) {
            return Observable.interval(interval).startWith(0)
                .switchMap(() => this.http.get(this.formUrl()))
        } else {
            return Observable.interval(interval)
                .switchMap(() => this.http.get(this.formUrl()))
        }
    }

    formUrl() {
        if ( this.lastQueryTime && this.lastQueryTime !== 0 ) {
            return HttpUtils.getBaseUrl() + url + '?lastQueryTime=' + this.lastQueryTime;
        } else {
            return HttpUtils.getBaseUrl() + url;
        }
    }

    subscribeForJobs() {
        if ( !this.subscription ) {
            this.subscription = this.pollJobs().subscribe(res => {
                    this.pollFailCount = 0;
                    this.filterJobs(res);
                },
                error => this.onPollFailure(),
                () => { }
            );
            console.log('jobs poller subscribed');
        }
    }

    onPollFailure() {
        this.pollFailCount += 1;
        this.subscription = undefined;
        if ( this.pollFailCount < 3 ) {
            console.log('failed. Retrying...' + this.pollFailCount);
            this.subscribeForJobs();
        } else {
            console.log('jobs poller unsubscribed');
            this.lastQueryTime = 0;
        }
    }

    filterJobs(res) {
        let jobs = [];
        let runningJobsCount = 0;
        if ( res && res.data ) {
            if ( res.data.lastQueryTime ) {
                this.lastQueryTime = res.data.lastQueryTime;
            }
            if ( res.data.jobs ) {
                jobs = res.data.jobs;
            }
            runningJobsCount = res.data.totalRunningJobs;
        }
        if ( jobs && jobs.length !== 0 ) {
            this.jobNotifier.setJobs(jobs);
            this.jobNotifier.setRefreshActivityLogEvent();
        }
        if ( runningJobsCount && runningJobsCount > 0) {
            this.jobNotifier.setRunningJobsCount(runningJobsCount);
        } else {
            this.jobNotifier.setRunningJobsCount(0);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/job-poller.service.ts